import type { UserPitrPreview } from '$lib/admin/userPitr';
import { BaseApiService } from './ApiService';

// const API_BASE_URL = '/api/v1';

class AdminService extends BaseApiService {
  static async createUser(name: string, email: string): Promise<any> {
    const apiInstance = await BaseApiService.getInstance();
    return apiInstance.execute('/api/v1/admin/create-user', {
      method: 'POST',
      body: JSON.stringify({ name, email }),
    });
  }

  static async changePassword(email: string, newPassword: string): Promise<any> {
    const apiInstance = await BaseApiService.getInstance();
    return apiInstance.execute('/api/v1/admin/change-password', {
      method: 'PUT',
      body: JSON.stringify({ email, newPassword }),
    });
  }

  static async deleteUser(email: string): Promise<any> {
    const apiInstance = await BaseApiService.getInstance();
    return apiInstance.execute('/api/v1/admin/delete-user', {
      method: 'PUT',
      body: JSON.stringify({ email }),
    });
  }

  static async changeMollieEmail(from: string, to: string): Promise<any> {
    const apiInstance = await BaseApiService.getInstance();
    return apiInstance.execute('/api/v1/admin/change-mollie-email', {
      method: 'POST',
      body: JSON.stringify({ from, to }),
    });
  }

  static async changeFirebaseAuthEmail(from: string, to: string): Promise<any> {
    const apiInstance = await BaseApiService.getInstance();
    return apiInstance.execute('/api/v1/admin/change-fb-auth-email', {
      method: 'POST',
      body: JSON.stringify({ from, to }),
    });
  }

  static async verifyEmail(email: string): Promise<any> {
    const apiInstance = await BaseApiService.getInstance();
    return apiInstance.execute('/api/v1/admin/verify-email', {
      method: 'PUT',
      body: JSON.stringify({ email }),
    });
  }

  static async searchUsers(query: string, fields?: string[] | string): Promise<any> {
    const apiInstance = await BaseApiService.getInstance();
    const params = new URLSearchParams();
    params.append('q', query);

    if (fields) {
      // Convert array to comma-separated string if it's an array
      const fieldsParam = Array.isArray(fields) ? fields.join(',') : fields;
      params.append('fields', fieldsParam);
    }

    return apiInstance.execute(`/api/v1/admin/search-users?${params.toString()}`, {
      method: 'GET',
    });
  }

  static async createCloudJob(taskId: string, parameters: Record<string, unknown>, data: unknown): Promise<any> {
    const apiInstance = await BaseApiService.getInstance();
    return apiInstance.execute('/api/v1/admin/create-job', {
      method: 'POST',
      body: JSON.stringify({
        taskId,
        data,
        parameters,
      }),
    });
  }

  static async getEntitlements(): Promise<any> {
    const apiInstance = await BaseApiService.getInstance();
    return apiInstance.execute('/api/v1/admin/entitlements', {

      method: 'GET',
    });
  }

  static async exportAffiliateEarnings(): Promise<string> {
    const apiInstance = await BaseApiService.getInstance();
    return apiInstance.execute('/api/v1/admin/affiliate-earnings.csv', {
      method: 'GET',
    });
  }

  static async exportBusinessMetrics(): Promise<string> {
    const apiInstance = await BaseApiService.getInstance();
    return apiInstance.execute('/api/v1/admin/business-metrics.csv', {
      method: 'GET',
    });
  }

  static async exportBusinessEvents(
    table: 'payments' | 'subscriptions',
    exportKey: string
  ): Promise<string> {
    const apiInstance = await BaseApiService.getInstance();
    return apiInstance.execute(`/api/v1/admin/business-events.csv?table=${table}`, {
      method: 'GET',
      headers: { 'X-Export-Key': exportKey },
    });
  }

  static async previewUserPitr(uid: string, readTime: string): Promise<UserPitrPreview> {
    const apiInstance = await BaseApiService.getInstance();
    return apiInstance.execute(`/api/v1/admin/users/${encodeURIComponent(uid)}/pitr-preview`, {
      method: 'POST',
      body: JSON.stringify({ readTime }),
    });
  }

  static async restoreUserPitr(uid: string, readTime: string): Promise<{ ok: true; readTime: string }> {
    const apiInstance = await BaseApiService.getInstance();
    return apiInstance.execute(`/api/v1/admin/users/${encodeURIComponent(uid)}/pitr-restore`, {
      method: 'POST',
      body: JSON.stringify({ readTime }),
    });
  }

  static async listBunnyStorage(
    path: string = '',
    q: string = ''
  ): Promise<{
    path: string;
    folders: Array<{ name: string; path: string }>;
    files: Array<{ name: string; path: string; cdnUrl: string; length: number }>;
  }> {
    const apiInstance = await BaseApiService.getInstance();
    const params = new URLSearchParams();
    if (path) params.set('path', path);
    if (q) params.set('q', q);
    const query = params.toString();
    return apiInstance.execute(`/api/v1/admin/bunny-storage${query ? `?${query}` : ''}`, {
      method: 'GET',
    });
  }
}

export default AdminService;
